/**
 * Utility functions for handling filter pill operations
 */
/**
 * Maps filter pill metadata to the corresponding filter properties that need to be cleared
 * @param pill - The pill that was removed
 * @returns Object with filter properties to clear
 */
export const getFilterPropertiesToRemove = (pill) => {
    const metadata = pill?.metadata;
    const filterNeedToRemove = {};
    switch (metadata) {
        case "publishedDate":
            filterNeedToRemove.startPublishedDate = "";
            filterNeedToRemove.endPublishedDate = "";
            break;
        case "referenceDate":
            filterNeedToRemove.startReferenceDate = "";
            filterNeedToRemove.endReferenceDate = "";
            break;
        case "downloadedDate":
            filterNeedToRemove.startDownloadedDate = "";
            filterNeedToRemove.endDownloadedDate = "";
            break;
        case "receivedDate":
            filterNeedToRemove.startReceivedDate = "";
            filterNeedToRemove.endReceivedDate = "";
            break;
        case "dueDate":
            filterNeedToRemove.startDueDate = "";
            filterNeedToRemove.endDueDate = "";
            break;
        case "metadataModificationDate":
            filterNeedToRemove.startMetadataModificationDate = "";
            filterNeedToRemove.endMetadataModificationDate = "";
            break;
        default:
            filterNeedToRemove[metadata] = [];
    }
    return filterNeedToRemove;
};
/**
 * Creates a handler for filter pill removal
 * @param event - Pillbox changed event
 * @returns Filter properties to remove
 */
export const handleFilterPillRemoval = (event) => {
    const pill = event.detail?.pill;
    return getFilterPropertiesToRemove(pill);
};
